// ============================================================
// WHITE-LABEL BRAND CONFIG — this is the ONLY file (plus
// tailwind.config.js colors, /public/images, and the services
// list in constants.ts) you edit to re-skin this site for a new
// client. See WHITELABEL.md for the full clone checklist.
// ============================================================

export const BRAND = {
  // Identity
  name: "Joe's Barber Shop",
  shortName: "Joe's",
  legalName: "Joe's Barber Shop",
  tagline: "Freehold's Original Since Day One",
  vertical: 'barbershop' as 'cleaning' | 'barbershop' | 'other',

  // Contact
  phone: '(732) 462-4012',
  phoneHref: 'tel:7324624012',
  email: 'book@joesbarbershopnj.com',
  domain: 'joesbarbershopnj-demo.pages.dev',

  // Assets (drop replacements into /public/images)
  logo: '/images/logo.svg',

  // Service area
  serviceArea: "13 South St, Freehold, NJ",

  // Trust signals shown in the homepage trust strip
  trust: {
    bondedInsured: false,
    satisfactionGuarantee: true,
    yearsInBusiness: null as number | null,
    ecoFriendly: false,
  },

  // Social — leave '' to hide a link
  social: {
    facebook: '',
    instagram: '',
    google: '', // Google Business profile / reviews URL
  },

  // Wording that differs per vertical ("cleaning" vs "appointment" language)
  bookingNoun: 'appointment',        // e.g. barbershop: 'appointment'
  workerNoun: 'barber',    // e.g. barbershop: 'barber'
};

export default BRAND;
